type latlon = {
  latitude: number
  longitude: number
}

export function asTheCrowFlies(pointA: latlon, pointB: latlon, units = 'mi') {
  const x =
    (pointB.longitude - pointA.longitude) *
    Math.cos((pointA.latitude + pointB.latitude) / 2)
  const y = pointB.latitude - pointA.latitude
  return (
    Math.sqrt(x * x + y * y) *
    (units === 'mi' ? 3958.8 : units === 'km' ? 6371.0 : 0)
  )
}

export function geoCentre(points: latlon[]) {
  const toRad = (deg: number) => (deg * Math.PI) / 180
  const toDeg = (rad: number) => (rad * 180) / Math.PI

  let x = 0,
    y = 0,
    z = 0

  points.forEach(({ latitude: lat, longitude: lon }) => {
    const phi = toRad(lat)
    const lam = toRad(lon)

    x += Math.cos(phi) * Math.cos(lam)
    y += Math.cos(phi) * Math.sin(lam)
    z += Math.sin(phi)
  })

  const total = points.length
  x /= total
  y /= total
  z /= total

  const lon = Math.atan2(y, x)
  const hyp = Math.sqrt(x * x + y * y)
  const lat = Math.atan2(z, hyp)

  return { lat: toDeg(lat), lon: toDeg(lon) }
}

// Example: Chester, London, Manchest
